import { render, staticRenderFns } from "./AgendaWeek.vue?vue&type=template&id=3bae66f2&scoped=true"
import script from "./AgendaWeek.vue?vue&type=script&lang=js"
export * from "./AgendaWeek.vue?vue&type=script&lang=js"
import style0 from "./AgendaWeek.vue?vue&type=style&index=0&id=3bae66f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bae66f2",
  null
  
)

export default component.exports